import React from 'react';
import { Icon } from '../../../ui/universe';

/**
 * Image 渲染器 - 用于图像处理结果
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 */
const ImageRenderer = ({ params, config }) => {
  const imageField = config.imageResultField || 'Image';

  if (!params[imageField]) {
    return null;
  }

  return (
    <div className="ocr_tips__success">
      <Icon size={24} name="success" color="#00b175" />
      <span>处理成功</span>
    </div>
  );
};

export default ImageRenderer;
